module.exports = __webpack_public_path__ + "img/az_logo.f8600c7d.png";